import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import cx from "classnames";
import styles from "./Card.less";
export function Card(props) {
  return React.createElement("article", _extends({}, props, {
    className: cx(styles.Card, props.className)
  }), props.children);
}
export function CardHeader(props) {
  return React.createElement("header", {
    className: cx(styles.CardHeader, props.className)
  }, props.children);
}
export function CardContent(props) {
  return React.createElement("main", _extends({}, props, {
    className: cx(styles.CardContent, props.className)
  }), props.children);
}
export function CardFooter(props) {
  return React.createElement("footer", {
    className: cx(styles.CardFooter, props.className)
  }, props.children);
}